import UserDetailPage from "./UserDetailPage";
import ProgramGoalPage from "./ProgramGoalPage";

export default class ProgramGoalUserPage extends UserDetailPage {
  static PageInfo = { 
    parent: ProgramGoalPage,
    hidden: true,
    path: "/Program/Detail/:id/Goal/:goal/User/:target",
    name: "menu.user",
    permission: { "CONFIGURATION_USERS_ACCESSING": true, "GOAL_APPROVE_CUSTOMER_ADMIN" : true, "GOAL_APPROVE_CUSTOMER_USER" : true},
    icon: "user"
  }
}  